/** @module SiteAdmin/User/SkinThemeController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/ActionView",
	"csi/enums",
	"csi/def",
	"csi/heading/AttributeController",
	"csi/locale",
	"csi/reflection",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/store/Nodes",
	"csi/xml"
], function(declare, _, ActionView, enums, def, AttributeController, locale, reflection, sessionConstants, {sessionStore}, Nodes, xml) {

	const CSS_ATTR = "_CSS";
	const ID_ATTR = "_ID";

	return declare(AttributeController, {
		/** @property {Store} themeStore - Store of the skin theme */
		themeStore: null,

		/** @property {string} matchUserSkinTheme - In the case of selecting site level skin theme, set to true 
		 * if the original site skin theme matches the user's */
		matchUserSkinTheme: false,

		/**
		 * @override
		 * Initialize the view
		 */
		getActionView: function(vr) {
			const rc = reflection.getClass("UserDetails");
			const defView = def.getClassViewDef(rc, "SkinThemes");

			return new ActionView(this, defView, this.getNode());
		},

		/**
		 * @override
		 * Save the theme if changes made, also take the user into account
		 */
		process: function() {
			const node = this.getFormData().getSelectedNode();
			const newSkinTheme = node && node[ID_ATTR];
			const originalSkinTheme = this.oldValue;

			this.newValue = newSkinTheme || originalSkinTheme;

			if (xml.isEmptyURL(this.getParentURL())) {
				// in the case of changing the site level setting
				this.matchUserSkinTheme = this.oldValue === sessionStore.userDetails.SkinTheme;
			}

			this.inherited(arguments);
		},

		/**
		 * Return true if the user is the current user
		 * Also, return true if the user is changing the site level theme and matches their own
		 * @return {boolean}
		 */
		_isSameUser: function() {
			return sessionConstants.userUrl === this.getParentURL() || this.matchUserSkinTheme;
		},

		/**
		 * @override
		 * Revert the theme if the user preview a theme different with the original one
		 */
		onEnd: function() {
			if (!this._isSameUser() || !this.newValue) {
				sessionStore.setSkinTheme(this.oldValue);
			}
		},

		/**
		 * @override
		 * Pre-select the original theme, and allow only selecting one theme
		 */
		onFormData(fd) {
			const selectedTheme = this.oldValue;
			fd.m_bSelectOne = true;
			fd.m_bRequireOne = true;

			// preview the theme
			fd.addSelectListener((ctx) => {
				const skinTheme = ctx.getNode()[ID_ATTR];
				sessionStore.setSkinTheme(skinTheme);
			});

			const themeStore = this._getStore();
			const selectedNode = _.filter(themeStore.query(), (item) => {
				return item[ID_ATTR] === selectedTheme;
			});

			fd.addAggregatedNode(selectedNode[0]);
		},

		/**
		 * @override
		 * Specify the store
		 */
		onCreatePopupParams: function(params) {
			params.store = this._getStore();
		},

		/**
		 * Create store of skin themes
		 * @return {Store}
		 */
		_getStore: function() {
			if (this.themeStore) {
				return this.themeStore;
			}

			const cache = this.widget.getCache();
			const type = reflection.TYPE_IMAGE;
			const store = enums.getStore("SkinTheme", null, null, true);

			const nodes = store.query().map((item) => {
				const skinThemeName = locale.getEnumName(item.id);
				const skinThemeValue = xml.enumGetText(item.id);
				const node = cache.createClientNode(null, type, skinThemeName);

				node[ID_ATTR] = store.getIdentity(item);
				node[CSS_ATTR] = "csi-theme-" + skinThemeValue.toLocaleLowerCase();
				return node;
			});

			this.themeStore = new Nodes({
				cachingStore: cache,
				data: nodes
			});

			return this.themeStore
		}
	});
});